module.exports = __webpack_public_path__ + "static/Crowns 3 intraoral before-0ac6f91abf505cb5f4a79d99da0557ea.jpg";